import { HttpResponse } from 'models';
import axiosClient, { handleRequest } from './axiosClient';
import { AxiosRequestConfig } from 'axios';
import { DepositReponseModel } from 'models/deposit';
import { CreateFiatWithdrawRequestBody, WithdrawRequestBody, WithdrawSettingsResponseModel } from 'models/withdraw';
import { getLocalStorage } from 'utils/sessionStorage';

const withdrawApi = {
  withdraw: (
    request: WithdrawRequestBody,
    headers: AxiosRequestConfig,
  ): Promise<HttpResponse<DepositReponseModel>> => {
    const url = `/wallet/api/withdraw`;
    return handleRequest(axiosClient.post(url, request, headers));
  },
  getWithdrawSettings: (): Promise<HttpResponse<WithdrawSettingsResponseModel>> => {
    const url = '/wallet/api/withdraw-settings/1';
    return handleRequest(
      axiosClient.get(url, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  createFiatWithdraw: (
    request: CreateFiatWithdrawRequestBody,
  ): Promise<HttpResponse<DepositReponseModel>> => {
    const url = `/wallet/api/fiat-withdraws`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
};

export default withdrawApi;
